// @flow
import { system, type Config } from 'styled-system';
import type { TextColor } from '@rover/design-system/style-dictionary/build/es6/theme';
import { createTransformWithDefault } from './transforms';

export type TextColorProps = {|
  textColor?: TextColor,
|};

const config: Config<TextColorProps> = {
  textColor: {
    property: 'color',
    scale: 'textColor',
    transform: createTransformWithDefault(undefined),
  },
};

export default system<TextColorProps>(config);



// WEBPACK FOOTER //
// ../react-lib/src/styles/styled-system/textColor.js